export default __webpack_public_path__ + "static/media/home-main.541f8179.svg";